<template>
<div>
  <!-- Right Side Menu and Avatar -->
  <v-menu v-model="menuActive" :nudge-width="100" :nudge-bottom="45" :nudge-left="35">
    <Avatar slot="activator" style="width: 40px; height: 40px;" v-if="user" :user="{
              displayName: user.displayName,
                     photoURL: user.photoURL
                   }" />
    <div v-else slot="activator" style="background-color: #3c3c3c; border-radius: 50%; height: 40px; width: 40px;" class="loading loading-lg"></div>
    <v-card>
      <v-list>
        <v-list-tile>
          <v-list-tile-title>
            <p v-if="user" class="h5 text-center text-ellipsis">
              {{ user.displayName }}
            </p>
          </v-list-tile-title>
        </v-list-tile>
        <v-divider></v-divider>
        <profile-settings v-if="user" profile-settings :user="this.user" :photoURL="user.photoURL" @closeSettings="isSettingsActive = false;" v-show="isSettingsActive" />
        <v-list-tile @click="logOut">
          <v-list-tile-content>
            <v-list-tile-title>
              Log Out
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-menu>
</div>
</template>

<script>
import Avatar from "@/components/User/Avatar";
import ProfileSettings from "@/components/User/ProfileSettings";
import firebase, {
  FirebaseConsts,
  db
} from "@/firebaseConfig";
export default {
  name: "NavBar",
  components: {
    Avatar,
    ProfileSettings
  },
  data: function() {
    return {
      menu: false,
      menuActive: false,
      isSettingsActive: true,
      user: null,
      firestoreUser: null
    };
  },
  mounted() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        this.$store.commit("setUID", user.uid);
      }
    });
  },
  methods: {
    getTime(time) {
      try {
        let hour = parseInt(time.split(":")[0]);
        let minutes = time.split(":")[1];
        return ((hour + 11) % 12) + 1 + ":" + minutes;
      } catch (err) {
        // console.log(err);
      }
    },
    getAbrev(days) {
      let string = "";
      days.forEach(day => {
        if (day === "Thursday") {
          string += day.slice(0, 2) + " ";
        } else {
          string += day.charAt(0).toUpperCase() + " ";
        }
      });
      return string;
    },
    logOut: function() {
      firebase.auth().signOut();
      this.$router.push("/");
    },
    switchGroup(id) {
      this.$router.push(`/${id}/home`);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Navigation/NavBar.vue